/* eslint-disable react/jsx-no-target-blank */
import { KTIcon } from '../../../helpers'
import { SidebarMenuItem } from './sidebar-menu/SidebarMenuItem'
import { useDispatch } from 'react-redux'

const SidebarFooter = () => {
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch({ type: 'USER_LOGOUT' })
  }
  return (
    <div className='app-sidebar-footer flex-column-auto' id='kt_app_sidebar_footer'>
      {/* <a
        href={process.env.REACT_APP_PREVIEW_DOCS_URL}
        target='_blank'
        className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='Metronic Docs & Components'
      >
        <span className='btn-label'>Docs & Components</span>
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
      </a> */}
      <div className='app-sidebar-wrapper'>
        <div className='menu menu-column menu-rounded menu-sub-indention px-3'>
          {/* <SidebarMenuItem to='/about' icon='element-11' title='About' fontIcon='bi-app-indicator' /> */}
          <SidebarMenuItem
            to='/contact'
            // icon='element-11'
            title='Contact Us'
            path='contact'
          />
          <SidebarMenuItem
            to='/tnc'
            // icon='element-11'
            title='Terms of Use'
            path='termsofuse'
          />
        </div>
        <div>
          <div className='menu-item'>
            <div className='menu-link' onClick={handleLogout}>
              <svg className='menu-icon' width='18' height='18' viewBox='0 0 22.414 20'>
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_9214'
                  data-name='Path 9214'
                  d='M626,684l4,4m0,0-4,4m4-4H617m6-7.8a8.382,8.382,0,0,0-4.333-1.2,9.006,9.006,0,0,0,0,18A8.382,8.382,0,0,0,623,695.8'
                  transform='translate(-609 -678)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              </svg>
              <span className='menu-title menu-gap'>Logout</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { SidebarFooter }
